<template>
  <div class="blog-layout">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'BlogLayout',
}
</script>


// WEBPACK FOOTER //
// src/layout/BlogLayout.vue